import { titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		display: 'flex',
		flexDirection: 'row',
		marginTop: 30,
	},
	container: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
	},
	content: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 400,
	},
	image: {
		left: -175,
		position: 'absolute',
		top: 15,
		zIndex: -1,
	},
	infoContainer: {
		color: '#4a4a4a',
		fontSize: 14,
		marginTop: 48,
		textAlign: 'center',
	},
	infoTagContainer: {
		alignItems: 'center',
		display: 'inline-flex',
		...CssSelectors.allChildren({
			margin: '5px auto',
		}),
	},
	infoTitle: {
		fontWeight: 'bold',
	},
	inputField: {
		height: 250,
		resize: 'none',
		width: 400,
	},
	message: {
		color: '#4a4a4a',
		fontSize: 14,
		lineHeight: '18px',
		marginBottom: 16,
		textAlign: 'center',
	},
	textAreaContainer: {
		position: 'relative',
	},
	title: {
		color: titles,
		fontSize: 18,
		marginBottom: 26,
	},
});
